import { type FormEvent, useState } from 'react';
import { Icon, type IconName } from '../../components/Icon.js';
import { useToast } from '../../components/Toast.js';
import { api } from '../../lib/api.js';

// Layar login — struktur HTML & class sama persis dengan <section id="login"> di v1 (public/index.html + boot() di admin.js).
const FEAT: [IconName, string][] = [
  ['bag', 'SPO digital dari toko'],
  ['bike', 'Pengiriman cepat'],
  ['pin', 'Live tracking GPS'],
  ['shield', 'Pembayaran tercatat aman'],
  ['tag', 'Rekap & margin otomatis'],
];

export function Login({ brand, onLoggedIn }: { brand: string; onLoggedIn: () => void }) {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const toast = useToast();

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const f = e.currentTarget;
    const username = (f.elements.namedItem('username') as HTMLInputElement).value;
    const pw = f.elements.namedItem('password') as HTMLInputElement;
    setError('');
    setBusy(true);
    try {
      const r = await api<{ user: { name: string } }>('POST', '/api/auth/login', { username, password: pw.value });
      pw.value = '';
      toast(`Selamat datang, ${r.user.name}.`);
      onLoggedIn();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <section id="login" className="login" aria-label="Login">
      <div className="login-poster">
        <div className="brand brand-lg">
          <div className="logo-mark" id="loginLogo">
            <Icon n="bag" />
          </div>
          <div>
            <b id="loginBrand">{brand}</b>
          </div>
        </div>
        <h1 className="poster-h">
          Penjualan
          <br />
          <em>Digital</em>
          <br />
          Distribusi
        </h1>
        <p className="poster-sub">Dari SPO sampai uang masuk, semua dalam genggaman.</p>
        <ul className="feat" id="loginFeat">
          {FEAT.map(([i, l]) => (
            <li key={i}>
              <span className="ic">
                <Icon n={i} />
              </span>
              {l}
            </li>
          ))}
        </ul>
      </div>
      <form id="loginForm" className="login-card" autoComplete="on" onSubmit={submit}>
        <div>
          <h2 id="loginTitle">Selamat datang 👋</h2>
          <p className="muted">Masuk untuk mulai SPO, kirim &amp; rekap.</p>
        </div>
        <label className="f">
          Username
          {/* Tanpa autoFocus: di v1 atribut autofocus tidak berlaku (layar login masih tersembunyi saat dimuat),
              jadi kolom tidak aktif otomatis dan keyboard HP tidak langsung muncul. */}
          <input className="inp" name="username" autoComplete="username" autoCapitalize="none" required />
        </label>
        <label className="f">
          Password
          <input className="inp" name="password" type="password" autoComplete="current-password" required />
        </label>
        <div id="loginError" className="form-error" role="alert">
          {error}
        </div>
        <button className="btn btn-primary btn-block btn-lg" type="submit" disabled={busy}>
          Masuk
        </button>
        <p className="muted small center">SPO · Nota · Pengiriman · Stok · Rekap</p>
      </form>
    </section>
  );
}
